import type { JSX } from "react";

import purify from "dompurify";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { usePageTopBannerStripReveal } from "app/components/PageTopBanner/bannerRevealContext";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import {
    ActionsWrapper,
    BannerContainer,
    CloseIconWrapper,
    CTAButton,
    TextWithIconWrapper,
    TextWrapper,
} from "./Banner.styles";

interface IAddonBannerProps {
    icon?: JSX.Element;
    dataAutomationId?: string;
    className?: string;
    descriptionTranslationKey: string;
    bannerCTATranslationKey: string;
    onCtaButtonClick: () => void;
    onCloseClicked?: () => void;
}

export const AddonBanner = ({
    icon,
    dataAutomationId,
    className,
    descriptionTranslationKey,
    bannerCTATranslationKey,
    onCtaButtonClick,
    onCloseClicked,
}: IAddonBannerProps) => {
    const translate = useTranslation();
    const stripProps = usePageTopBannerStripReveal();

    return (
        <BannerContainer
            data-automation={dataAutomationId}
            {...stripProps}
            className={className}
        >
            <TextWithIconWrapper>
                {icon}

                <TextWrapper>
                    <Text
                        fontVariant="input2"
                        padding="0 0 0 12px"
                        dangerouslySetInnerHTML={{
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            __html: purify.sanitize(translate(descriptionTranslationKey)),
                        }}
                    />
                </TextWrapper>
            </TextWithIconWrapper>
            <ActionsWrapper>
                <CTAButton
                    type="inverted"
                    onClick={onCtaButtonClick}
                >
                    {translate(bannerCTATranslationKey)}
                </CTAButton>

                {onCloseClicked ? (
                    <CloseIconWrapper onClick={onCloseClicked}>
                        <SWReactIcons
                            iconName="close"
                            iconColor={colorsPalettes.carbon[0]}
                            size="xs"
                        />
                    </CloseIconWrapper>
                ) : null}
            </ActionsWrapper>
        </BannerContainer>
    );
};
